import React from 'react';
import PropTypes from 'prop-types';

export default class Comments extends React.Component {
	render() {
		/* eslint react/no-danger: 0 */
		/* filtered in server side code */
		return (
			<div
				className="content"
				dangerouslySetInnerHTML={{ __html: this.props.comments }}
			/>
		);
	}
}

Comments.propTypes = {
	comments: PropTypes.string.isRequired
};
